import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";

const MainTableRow = ({ row, columns, handleDelete, handleEdit }) => {
  return (
    <TableRow hover role="checkbox" key={row.id}>
      {columns.map((column, i) => {
        const value = row[column.id];
        return (
          <TableCell key={column.id} align={column.align} style={column.style}>
            {column.id === "is_default" ? (
              value === 1 ? (
                "Default"
              ) : (
                ""
              )
            ) : column.id === "action" ? (
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Edit">
                  <IconButton onClick={() => handleEdit(row)}>
                    <Edit />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Delete">
                  <IconButton onClick={() => handleDelete(row.id)}>
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              value
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default MainTableRow;
